/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { LocationCreateDTO } from '../models';
// @ts-ignore
import type { LocationResponseDTO } from '../models';
// @ts-ignore
import type { LocationUpdateDTO } from '../models';
// @ts-ignore
import type { PageLocationResponseDTO } from '../models';
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationApiV1LocationsPost: async (locationCreateDTO: LocationCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationCreateDTO' is not null or undefined
            assertParamExists('createLocationApiV1LocationsPost', 'locationCreateDTO', locationCreateDTO)
            const localVarPath = `/api/v1/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationApiV1LocationsPost_1: async (locationCreateDTO: LocationCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationCreateDTO' is not null or undefined
            assertParamExists('createLocationApiV1LocationsPost_1', 'locationCreateDTO', locationCreateDTO)
            const localVarPath = `/api/v1/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationApiV1LocationsLocationIdDelete: async (locationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocationApiV1LocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationApiV1LocationsLocationIdDelete_2: async (locationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocationApiV1LocationsLocationIdDelete_2', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationApiV1LocationsLocationIdGet: async (locationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationApiV1LocationsLocationIdGet', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationApiV1LocationsLocationIdGet_3: async (locationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationApiV1LocationsLocationIdGet_3', 'locationId', locationId)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsApiV1LocationsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsApiV1LocationsGet_4: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCityApiV1LocationsByCityGet: async (city: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'city' is not null or undefined
            assertParamExists('listLocationsByCityApiV1LocationsByCityGet', 'city', city)
            const localVarPath = `/api/v1/locations/by-city`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCityApiV1LocationsByCityGet_5: async (city: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'city' is not null or undefined
            assertParamExists('listLocationsByCityApiV1LocationsByCityGet_5', 'city', city)
            const localVarPath = `/api/v1/locations/by-city`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCountryApiV1LocationsByCountryGet: async (country: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('listLocationsByCountryApiV1LocationsByCountryGet', 'country', country)
            const localVarPath = `/api/v1/locations/by-country`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCountryApiV1LocationsByCountryGet_6: async (country: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('listLocationsByCountryApiV1LocationsByCountryGet_6', 'country', country)
            const localVarPath = `/api/v1/locations/by-country`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationsByNameApiV1LocationsSearchGet: async (name: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchLocationsByNameApiV1LocationsSearchGet', 'name', name)
            const localVarPath = `/api/v1/locations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationsByNameApiV1LocationsSearchGet_7: async (name: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchLocationsByNameApiV1LocationsSearchGet_7', 'name', name)
            const localVarPath = `/api/v1/locations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationApiV1LocationsLocationIdPatch: async (locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocationApiV1LocationsLocationIdPatch', 'locationId', locationId)
            // verify required parameter 'locationUpdateDTO' is not null or undefined
            assertParamExists('updateLocationApiV1LocationsLocationIdPatch', 'locationUpdateDTO', locationUpdateDTO)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationApiV1LocationsLocationIdPatch_8: async (locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocationApiV1LocationsLocationIdPatch_8', 'locationId', locationId)
            // verify required parameter 'locationUpdateDTO' is not null or undefined
            assertParamExists('updateLocationApiV1LocationsLocationIdPatch_8', 'locationUpdateDTO', locationUpdateDTO)
            const localVarPath = `/api/v1/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocationApiV1LocationsPost(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocationApiV1LocationsPost(locationCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocationApiV1LocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocationApiV1LocationsPost_1(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocationApiV1LocationsPost_1(locationCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocationApiV1LocationsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocationApiV1LocationsLocationIdDelete(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocationApiV1LocationsLocationIdDelete(locationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.deleteLocationApiV1LocationsLocationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocationApiV1LocationsLocationIdDelete_2(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocationApiV1LocationsLocationIdDelete_2(locationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.deleteLocationApiV1LocationsLocationIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationApiV1LocationsLocationIdGet(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationApiV1LocationsLocationIdGet(locationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationApiV1LocationsLocationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationApiV1LocationsLocationIdGet_3(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationApiV1LocationsLocationIdGet_3(locationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.getLocationApiV1LocationsLocationIdGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsApiV1LocationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsApiV1LocationsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsApiV1LocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsApiV1LocationsGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsApiV1LocationsGet_4(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsApiV1LocationsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsByCityApiV1LocationsByCityGet(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsByCityApiV1LocationsByCityGet(city, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsByCityApiV1LocationsByCityGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsByCityApiV1LocationsByCityGet_5(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsByCityApiV1LocationsByCityGet_5(city, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsByCityApiV1LocationsByCityGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsByCountryApiV1LocationsByCountryGet(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsByCountryApiV1LocationsByCountryGet(country, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsByCountryApiV1LocationsByCountryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsByCountryApiV1LocationsByCountryGet_6(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsByCountryApiV1LocationsByCountryGet_6(country, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocationsByCountryApiV1LocationsByCountryGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocationsByNameApiV1LocationsSearchGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocationsByNameApiV1LocationsSearchGet(name, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.searchLocationsByNameApiV1LocationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLocationsByNameApiV1LocationsSearchGet_7(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLocationsByNameApiV1LocationsSearchGet_7(name, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.searchLocationsByNameApiV1LocationsSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationApiV1LocationsLocationIdPatch(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationApiV1LocationsLocationIdPatch(locationId, locationUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.updateLocationApiV1LocationsLocationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationApiV1LocationsLocationIdPatch_8(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationApiV1LocationsLocationIdPatch_8(locationId, locationUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.updateLocationApiV1LocationsLocationIdPatch_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationApiV1LocationsPost(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.createLocationApiV1LocationsPost(locationCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new location in the current organization. Requires \'location:write\' permission.
         * @summary Create Location
         * @param {LocationCreateDTO} locationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationApiV1LocationsPost_1(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.createLocationApiV1LocationsPost_1(locationCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationApiV1LocationsLocationIdDelete(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocationApiV1LocationsLocationIdDelete(locationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a location from the organization. Requires \'location:write\' permission.
         * @summary Delete Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationApiV1LocationsLocationIdDelete_2(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocationApiV1LocationsLocationIdDelete_2(locationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationApiV1LocationsLocationIdGet(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.getLocationApiV1LocationsLocationIdGet(locationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific location by ID. Requires \'location:view\' permission.
         * @summary Get Location
         * @param {string} locationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationApiV1LocationsLocationIdGet_3(locationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.getLocationApiV1LocationsLocationIdGet_3(locationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsApiV1LocationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsApiV1LocationsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all locations in the current user\'s organization. Requires \'location:view\' permission.
         * @summary List Locations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsApiV1LocationsGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsApiV1LocationsGet_4(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCityApiV1LocationsByCityGet(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsByCityApiV1LocationsByCityGet(city, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List locations by city within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By City
         * @param {string} city 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCityApiV1LocationsByCityGet_5(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsByCityApiV1LocationsByCityGet_5(city, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCountryApiV1LocationsByCountryGet(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsByCountryApiV1LocationsByCountryGet(country, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List locations by country within the current organization. Requires \'location:view\' permission.
         * @summary List Locations By Country
         * @param {string} country 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsByCountryApiV1LocationsByCountryGet_6(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.listLocationsByCountryApiV1LocationsByCountryGet_6(country, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationsByNameApiV1LocationsSearchGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.searchLocationsByNameApiV1LocationsSearchGet(name, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
         * @summary Search Locations By Name
         * @param {string} name 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLocationsByNameApiV1LocationsSearchGet_7(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageLocationResponseDTO> {
            return localVarFp.searchLocationsByNameApiV1LocationsSearchGet_7(name, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationApiV1LocationsLocationIdPatch(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.updateLocationApiV1LocationsLocationIdPatch(locationId, locationUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a location\'s information. Requires \'location:write\' permission.
         * @summary Update Location
         * @param {string} locationId 
         * @param {LocationUpdateDTO} locationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationApiV1LocationsLocationIdPatch_8(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<LocationResponseDTO> {
            return localVarFp.updateLocationApiV1LocationsLocationIdPatch_8(locationId, locationUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * Create a new location in the current organization. Requires \'location:write\' permission.
     * @summary Create Location
     * @param {LocationCreateDTO} locationCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public createLocationApiV1LocationsPost(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).createLocationApiV1LocationsPost(locationCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new location in the current organization. Requires \'location:write\' permission.
     * @summary Create Location
     * @param {LocationCreateDTO} locationCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public createLocationApiV1LocationsPost_1(locationCreateDTO: LocationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).createLocationApiV1LocationsPost_1(locationCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a location from the organization. Requires \'location:write\' permission.
     * @summary Delete Location
     * @param {string} locationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public deleteLocationApiV1LocationsLocationIdDelete(locationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).deleteLocationApiV1LocationsLocationIdDelete(locationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a location from the organization. Requires \'location:write\' permission.
     * @summary Delete Location
     * @param {string} locationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public deleteLocationApiV1LocationsLocationIdDelete_2(locationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).deleteLocationApiV1LocationsLocationIdDelete_2(locationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific location by ID. Requires \'location:view\' permission.
     * @summary Get Location
     * @param {string} locationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationApiV1LocationsLocationIdGet(locationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationApiV1LocationsLocationIdGet(locationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific location by ID. Requires \'location:view\' permission.
     * @summary Get Location
     * @param {string} locationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public getLocationApiV1LocationsLocationIdGet_3(locationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).getLocationApiV1LocationsLocationIdGet_3(locationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all locations in the current user\'s organization. Requires \'location:view\' permission.
     * @summary List Locations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsApiV1LocationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsApiV1LocationsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all locations in the current user\'s organization. Requires \'location:view\' permission.
     * @summary List Locations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsApiV1LocationsGet_4(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsApiV1LocationsGet_4(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List locations by city within the current organization. Requires \'location:view\' permission.
     * @summary List Locations By City
     * @param {string} city 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsByCityApiV1LocationsByCityGet(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsByCityApiV1LocationsByCityGet(city, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List locations by city within the current organization. Requires \'location:view\' permission.
     * @summary List Locations By City
     * @param {string} city 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsByCityApiV1LocationsByCityGet_5(city: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsByCityApiV1LocationsByCityGet_5(city, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List locations by country within the current organization. Requires \'location:view\' permission.
     * @summary List Locations By Country
     * @param {string} country 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsByCountryApiV1LocationsByCountryGet(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsByCountryApiV1LocationsByCountryGet(country, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List locations by country within the current organization. Requires \'location:view\' permission.
     * @summary List Locations By Country
     * @param {string} country 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocationsByCountryApiV1LocationsByCountryGet_6(country: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocationsByCountryApiV1LocationsByCountryGet_6(country, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
     * @summary Search Locations By Name
     * @param {string} name 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public searchLocationsByNameApiV1LocationsSearchGet(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).searchLocationsByNameApiV1LocationsSearchGet(name, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search locations by name pattern within the current organization. Requires \'location:view\' permission.
     * @summary Search Locations By Name
     * @param {string} name 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public searchLocationsByNameApiV1LocationsSearchGet_7(name: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).searchLocationsByNameApiV1LocationsSearchGet_7(name, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a location\'s information. Requires \'location:write\' permission.
     * @summary Update Location
     * @param {string} locationId 
     * @param {LocationUpdateDTO} locationUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public updateLocationApiV1LocationsLocationIdPatch(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).updateLocationApiV1LocationsLocationIdPatch(locationId, locationUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a location\'s information. Requires \'location:write\' permission.
     * @summary Update Location
     * @param {string} locationId 
     * @param {LocationUpdateDTO} locationUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public updateLocationApiV1LocationsLocationIdPatch_8(locationId: string, locationUpdateDTO: LocationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).updateLocationApiV1LocationsLocationIdPatch_8(locationId, locationUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

